import React, { Fragment } from "react";
import * as MD from "@material-ui/core";
import { usePagination, useSortBy, useTable } from "react-table";
import "../../react-table.css";

import { Dispatch } from "redux";
import { IApplicationState } from "../../Store";
import { connect } from "react-redux";
import styled from "styled-components";
import { Export } from "../Dashboard/Export";
import { I18N, ILocaleInfos } from "../../Store/I18n/Types";
import { IUserState } from "../../Store/User/Types";
import { IDashboardDetails, IDeclarationCSAFilters, IElectionsState, PRESIDENTIEL_ELECTION } from "../../Store/Elections/Types";
import { getDeclarationCSA, getXlsDeclarationCSA } from "../../Store/Elections/Actions";
import { ISearchState } from "../../Store/Search/Types";

import '@yacast/react-player/dist/index.css'

import { isNullOrUndefined } from "../../Utils/Various";
import { Dialog } from "../Dialog";
import { YacastPlayer } from "@yacast/react-player";
import { capitalize } from "../../Utils/String";
import { BiPlayCircle } from "react-icons/bi";
import { getExportDashboardDetailsPdf, getExportDashboardDetailsXls } from "../../Store/Export/Actions";
import { IFiltersDetail } from "../../Store/Dashboard/Types";

const Styles = styled.div `
  table {
    width: 100%;
    border-spacing: 0;
    border: 1px solid black;
    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }
    th,
    td {
      margin: 0;
      padding: 2px;
      :last-child {
        border-right: 0;
      }
    }
  }
  
  .pagination {
    padding: 0.1rem;
    background-color: darkgray;
    display: block;
    text-align: center;
  }
`
const styles = (theme:any) => MD.createStyles({
    root: {
      width: "100%",
    },
    paper: {
      width: "100%",
      clear:"both",
      marginBottom: theme.spacing(2),
    },
    table: {
      minWidth: 750,
    },
    toggleDiv:{
      width:"100%",
    },
    closeButton: {
      position: 'absolute',
      right: '8px',
      top: '5px',
      color: theme.palette.grey[500],
    },
    datePickerInput: {
      border:'none',
      marginRight: '10px',
      background: theme.palette.background.paper,
      color: theme.palette.text.secondary,
    },
    datePickerInputSmallFont: {
      fontSize: '12px',
      "& input": {
        textAlign: 'center',
        padding: '8px 4px',
        color: theme.palette.text.secondary,
        }
    },
    datePickerLabel: {
      fontSize: '13px',
      fontWeight: 500,
      color: theme.palette.text.primary,
      textTransform: 'capitalize',
      fontFamily: 'Lato',
      fontStyle: 'normal',
    },
  });
  type DialogAllProps = MD.WithStyles<typeof styles> & MD.WithTheme

export interface DialogTitleProps extends DialogAllProps {
  id: string;
  children: React.ReactNode;
  onClose: () => void;
  i18n: I18N;
  theme: any
}

interface IPropsFromState {
  i18n: I18N;
  user: IUserState;
  elections: IElectionsState;
  localeInfos: ILocaleInfos;
  search: ISearchState;
}

interface IPropsFromDispatch {
  getXlsDeclarationCSA: typeof getXlsDeclarationCSA
  getDeclarationCSA: typeof getDeclarationCSA
  getExportDashboardDetailsPdf: typeof getExportDashboardDetailsPdf
  getExportDashboardDetailsXls: typeof getExportDashboardDetailsXls
}
  
interface IOwnProps {
  columns?: any;
  data: any;
  showFilters: boolean;
  filters?: any;
  type?: string;
}

type AllProps =
    MD.WithTheme &
    MD.WithStyles &
    IPropsFromState &
    IPropsFromDispatch &
    IOwnProps;

interface IOwnState {
  originalData: any[];
  data: any[];
  columns: any[];
  mediasID: number[];
  study_type_id: number;
  setting_study_type: boolean;
  mediasStr: string[] | null;
  isAllMediaSelected: boolean;
  startDate: Date;
  endDate: Date;
  // player
  openPlayer: boolean;
  mediaIDtoPlay:number;
  rowPlayingID:number;
  mediaNametoPlay:string;
  startDatetoPlay:number;
  endDatetoPlay:number;
}
interface ITableProps {
  rowPlayingID: number,
  columns: any,
  data: any
}

function hiddenColumns(columns:any) {
  let hiddenColumns:any = [] // array of id type string
  hiddenColumns = columns.filter((x:any) => x.show === false)
  hiddenColumns = hiddenColumns.map((x:any) => x.accessor)
  return hiddenColumns
}
function setThStyle(column:any) {
    return {
      ...column.headerStyle,
    }
}

function setTrStyle(row:any, index: any, rowPlayingId?: number) {
  let style:any = {
    backgroundColor: index % 2 === 0 ? "rgb(68, 68, 78)" : "rgb(68, 68, 78, 0.97)",
    lineHeight: '15px',
    padding: 2
  }
  if (row.index === rowPlayingId) { 
    style= {
      ...style,
      backgroundColor: 'gray'
    }
  }
  return style
}
function setTdStyle(cell:any) {
  return (
    {
      textAlign: cell.column.id === 'nom' ? 'left' : 'center',
    }
  )
}
function Table(props:ITableProps) { 
  let columns:any = props.columns
  let data:any = props.data
  const {
    getTableProps, 
    getTableBodyProps, 
    headerGroups, 
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize }
  } = 
  useTable({
    columns, 
    data,
    initialState: {
      hiddenColumns: hiddenColumns(columns),
      pageIndex: 0, pageSize: 20 
    },
  },
  useSortBy,
  usePagination
  )

  const generateSortingIndicator = (column:any) => {
    return column.isSorted ? (column.isSortedDesc ? ' 🔽' : ' 🔼') : '';
  };
  // Render Data Table UI
  return (
    <Fragment>
    <table {...getTableProps()} 
    style={{
      borderColor: '#bdabab',
      background: 'rgb(218, 218, 218)',
      color: '#f6f1f1',
      fontWeight: 300,
    }}
    className="-striped -highlight">
      <thead>
        {headerGroups.map(headerGroup => {
          return (
            <tr {...headerGroup.getHeaderGroupProps()} >
              {headerGroup
                .headers
                .map((column:any, index:number) => {
                return (
                  <th {...column.getHeaderProps(column.getSortByToggleProps())}
                  style={{
                    ...setThStyle(column)
                  }}
                  title=''
                  >
                    {column.render('Header')}
                    {generateSortingIndicator(column)}
                  </th>
                )})
              }
            </tr>
          )}
        )}
      </thead>
      
      <tbody {...getTableBodyProps()}>
        {page.map((row, i) => {
          if (row !== null) {
            prepareRow(row);
            return (
              <Fragment key={row.getRowProps().key}>
              <tr
              style={setTrStyle(row, i, props.rowPlayingID)}
              >
                {row
                  .cells
                  .map((cell:any) => {
                    return (
                    <td {...cell.getCellProps()}
                    style={setTdStyle(cell) as any} 
                    >{cell.render('Cell')}</td>)
                  })}
              </tr>
              </Fragment>
            )
          } else return null
        })}
      </tbody>
    </table>
    
    <div className="pagination">
        <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
          {'<<'}
        </button>{' '}
        <button onClick={() => previousPage()} disabled={!canPreviousPage}>
          {'<'}
        </button>{' '}
        <button onClick={() => nextPage()} disabled={!canNextPage}>
          {'>'}
        </button>{' '}
        <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
          {'>>'}
        </button>{' '}
        <span style={{color: 'black'}}>
          Page{' '}
          <strong>
            {pageIndex + 1} de {pageOptions.length}
          </strong>{' '}
        </span>
        <select
          style={{width: '50px', padding: '1.5px'}}
          value={pageSize}
          onChange={e => {
            setPageSize(Number(e.target.value))
          }}
        >
          {[10, 20, 30, 40, 50].map(pageSize => (
            <option key={pageSize} value={pageSize} style={{color: 'black', textAlign: 'center' }}>
              {pageSize}
            </option>
          ))}
        </select>
      </div>
    </Fragment>
  )
}

export class ElectionTableDetailsComponent extends React.Component<AllProps, IOwnState> {
    public constructor(props: AllProps) {
        super(props);
        let filters:IDeclarationCSAFilters = {...props.elections.declarations_csa_filters} as any
        
        this.state = {
          startDate: filters !== null ? filters.date_start : new Date(),
          endDate: filters !== null ? filters.date_end : new Date(),
          originalData: [],
          data: [],
          columns: [],
          study_type_id: PRESIDENTIEL_ELECTION.FIRST_ROUND,
          mediasID: props.user.allMediasID,
          mediasStr: props.user.allMediasSTR,
          isAllMediaSelected: true,
          openPlayer: false,
          mediaIDtoPlay: -1,
          rowPlayingID: -1,
          mediaNametoPlay: '',
          startDatetoPlay: -1,
          endDatetoPlay: -1,
          setting_study_type: false
        }
    }
    public componentDidUpdate(prevProps: AllProps, prevState:IOwnState){
      
    }
    static getDerivedStateFromProps(props: AllProps, state: IOwnState) {
      if (props.elections.dashboard_elections_filters !== null && state.mediasStr === null) {
        let filters = props.elections.dashboard_elections_filters
        state.mediasID = filters.media_ids
        state.mediasStr = filters.media_str
        state.isAllMediaSelected = filters.media_ids.length === props.user.allMediasID.length
        state.study_type_id = filters.study_type_id
      }
      if (props.elections.time_allocation_filters !== null && !state.setting_study_type) {
        let filters = props.elections.time_allocation_filters

        state.study_type_id = filters.study_type_id
        state.setting_study_type = true
      }
      return state
    }

    private handleVideoPlayerClick = (event:React.MouseEvent<SVGSVGElement, MouseEvent>, row:any, mediaID:number) => {
      event.stopPropagation();
      event.preventDefault();
      this.setState({
        openPlayer: true,
        mediaIDtoPlay: mediaID,
        mediaNametoPlay: row.original.media,
        startDatetoPlay: (new Date(row.original.startDate)).getTime(),
        endDatetoPlay: (new Date(row.original.endDate)).getTime(),
        rowPlayingID: row.index
      })
    }
  private buildColumns() {
    const { i18n } = this.props
    let dataCopy:any = []
    let headerStyle= {
      backgroundColor: "#dadada",
      color: 'black',
      flex: '100 0 auto',
      fontSize: '0.875rem',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      fontWeight: 300,
      width: '70px',
      cursor: 'pointer'
    }
    this.props.data.map((x:IDashboardDetails) => {
      let jsonData:any = {}
      jsonData["media"] = x.media_name
      jsonData["mediaId"] = x.media_id
      jsonData["nom emission"] = x.emission_name
      jsonData["type emission"] = x.typeemission_name
      //jsonData["type emission code"] = x.typeemission_code
      jsonData["circonscription"] = x.study_detail_name
      jsonData["date"] = x.day
      jsonData["heure debut"] = x.date_start.split(' ')[1]
      jsonData["heure fin"] = x.date_end.split(' ')[1]
      jsonData["durée"] = x.duration_hms
      jsonData["qualité"] = x.person_function
      jsonData["intervenant"] = x.person_name
      jsonData["parti / candidat"] = x.political_group_name
      jsonData["editeur"] = x.program_editor_name
      jsonData["type etude"] = x.study_type_name
      jsonData["player"] = ""
      jsonData["startDate"] = x.date_start
      jsonData["endDate"] = x.date_end
      
      dataCopy.push(jsonData)
      return dataCopy
    })
    let columns:any = []
    dataCopy.map((x:any) => {
      Object.keys(x).map((key:any, index: number) => {
        if (x[key] === undefined || key === "mediaId" || key === "startDate" || key === "endDate") {
          columns[index] = {
            Header: capitalize(i18n._(`${key}`)),
            accessor: key,
            show: false,
          }
        } else if (key === 'player') {
          columns[index] = {
              Header: "Player",
              accessor: "player",
              show: true,
              headerStyle: {
                ...headerStyle,
                width: '50px'
              },
              minWidth: 50,
              Cell: (cell:any) => {
                let media_id = cell.row.original.mediaId
                let medias_source = this.props.search.mediasSource
                let media_source_id:any = null
                if (medias_source !== undefined && medias_source !== null) {
                  if (Object.keys(medias_source).length > 0) {
                    Object.keys(medias_source).map((key:any) => {
                      if(parseInt(key) === media_id) {
                        let media_source = medias_source[key]
                        if (media_source !== undefined && media_source[0] !== undefined && media_source[0] !== null) {
                          media_source_id = media_source[0].id
                        }
                      }
                      return media_source_id
                    })
                  }
                }
                if (media_source_id !== null) {
                  return (
                    <div style={{display: 'inline-flex'}}>
                      <MD.IconButton 
                      title={i18n._('Play selection')}
                      onClick={(event:any) => this.handleVideoPlayerClick(event, cell.row, media_source_id)}
                      >
                        <BiPlayCircle 
                        style={{ cursor: 'pointer', marginRight: '10px', fontSize:'smaller', color: this.props.theme.palette.primary.light }}
                        />
                      </MD.IconButton>
                      {/* <MD.IconButton 
                      title={i18n._('Download')}
                      >
                        <BiDownload style={{ cursor: 'pointer', fontSize:'smaller', color: theme.palette.primary.light }}/>
                      </MD.IconButton> */}
                      </div>
                  );
                } else return null
              },
            }
        } 
        else {
        columns[index] = {
            Header: capitalize(i18n._(`${key}`)),
            accessor: key,
            show: true,
            headerStyle: headerStyle,
            Cell: (cell:any) => {
              return  <span title={cell.value}>
                        {cell.value}
                      </span>
            }
          }
        }

        return columns
      })
      return columns
    })
    this.setState({ columns: columns, data: dataCopy, originalData: dataCopy})
  }
  componentDidMount(){
   if (this.props.columns === undefined) {
     this.buildColumns() 
   } else this.setState({
     columns: this.props.columns,
     data: this.props.data
    })
  }
  componentWillUnmount() {
    this.setState({
      data: []
    })
  }

  getTrProps = (state:any, rowInfo:any, instance:any) => {
    if (rowInfo) {
      return {
        style: {
          height: '25px'
        }
      }
    }
    return {};
  }

  private drawTable() {
    return (
      this.state.data.length > 0 ?
      <Styles>
        <Table
          rowPlayingID={this.state.rowPlayingID}
          data={this.state.data} 
          columns={this.state.columns}
        />
      </Styles>    
      : <div>
            {this.props.i18n._('No results')}  
        </div>      
    )
  }

  private buildDetailsDashboardExport(filters: IFiltersDetail) {
    return (
      <div style={{position: 'absolute', right: '15px', display: 'inline-flex'}}>
          {this.props.type !== "declarationsCSA" && <Export exportAction={this.props.getExportDashboardDetailsPdf}
          filters={filters} exportType = 'pdf' />}
          <Export exportAction={(filters) => this.props.type === 'declarationsCSA' ? this.props.getXlsDeclarationCSA(filters) : this.props.getExportDashboardDetailsXls(filters)} 
          filters={filters} exportType = 'xls' />
      </div>
  )}
  private onStartChange(date: any, value?: string | null | undefined) {
    if ((date === null) || (typeof date === 'undefined')) {
        return;
    }
    this.setState({startDate: date});
    this.props.getDeclarationCSA({
      media_ids: this.state.mediasID,
      study_type_id: this.state.study_type_id,
      date_start: date,
      date_end: this.state.endDate
    })
  }

  private onEndChange(date: any, value?: string | null | undefined) {
      if ((date === null) || (typeof date === 'undefined')) {
          return;
      }
      
      let end_date = new Date(date)
      end_date.setDate(date.getDate() + 1)
      this.setState({endDate: end_date});
      
      this.props.getDeclarationCSA({
        media_ids: this.state.mediasID,
        study_type_id: this.state.study_type_id,
        date_start: this.state.startDate,
        date_end: end_date
      })
  }

  private onSearch() {
    this.props.getDeclarationCSA({
      media_ids: this.state.mediasID,
      study_type_id: this.state.study_type_id,
      date_start: this.state.startDate,
      date_end: this.state.endDate
    })
  }
  
  private handleClose = () => {
    this.setState({
      openPlayer: false,
      rowPlayingID: -1
    });
  }
  private showVideoPlayer(tokenPlayer:string, mediaID:number, mediaName:string, startDate:number, endDate:number){
    let duration = (endDate - startDate) / 1000;
    let timelineDuration = duration + (30 * 60)
    return(
      <Dialog 
        closeDialog={this.handleClose.bind(this)} 
        open={this.state.openPlayer} 
        width={'700px'}
        content={
          <YacastPlayer
              apiKey={tokenPlayer}
              mediaName={mediaName}
              mediaID={mediaID}
              start={new Date(startDate - 1000)}
              autoplay={true}
              timelineDuration={timelineDuration}
              timelineHaveReadjustedEPG={true}
              timelineHaveMusicEPG={false}
              selectionEnd={new Date(endDate)}
              selectionStart={new Date(startDate)}
              initialZoom={0}
              aclToken={this.props.user.token}
            />
        } 
      />
    )
  }
  render() {
    let filters: any = this.props.filters;
    return ( 
      <>
      { this.state.openPlayer &&
          this.showVideoPlayer(
            this.props.user.tokenPlayer,
            this.state.mediaIDtoPlay, 
            this.state.mediaNametoPlay, 
            this.state.startDatetoPlay,
            this.state.endDatetoPlay
          ) 
        }
        <div id="export" style={{display: 'inline-flex', width: '60%'}}>
          { !isNullOrUndefined(filters) && this.state.data.length > 0 &&
            this.buildDetailsDashboardExport(filters)
          }
        </div>
        
        <div id="details-table" style={{paddingTop: "35px"}}> 
        { this.drawTable() }
      </div>
      </>
    )
  }
}

const mapStateToProps = ({i18n, user, elections, search} : IApplicationState) => {
  return {
    localeInfos: i18n.localeInfos,
    i18n: i18n.i18n,
    user,
    elections,
    search
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  getXlsDeclarationCSA: (filters:IDeclarationCSAFilters) => dispatch(getXlsDeclarationCSA(filters)),
  getDeclarationCSA: (filters:IDeclarationCSAFilters) => dispatch(getDeclarationCSA(filters)),
  getExportDashboardDetailsPdf: (filters: any) => dispatch(getExportDashboardDetailsPdf(filters)),
  getExportDashboardDetailsXls: (filters: any) => dispatch(getExportDashboardDetailsXls(filters)),
});

export const ElectionTableDetails = 
    connect(mapStateToProps, mapDispatchToProps)
    (MD.withTheme(MD.withStyles(styles)(ElectionTableDetailsComponent)));
